var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"AccessControl"},[_c('access',{ref:"AccessControl",attrs:{"isOPS":true,"level":"Property"},on:{"setAccessType":_vm.selectedAccessType}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }